<template>
  <div v-if="studentSieId">
    <PageHeader
      has-return
      :page="{
        icon: 'fas fa-file-edit',
        title: 'Evaluaciones del Estudiante',
        routes: ['Inicio', 'Evaluaciones del Estudiante'],
      }"
    />

    <StudentEvaluationsHistory :student-sie-id="studentSieId" />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import StudentEvaluationsHistory from '@/components/StudentEvaluationsHistory';

export default {
  name: 'EvaluationsHistory',
  components: { PageHeader, StudentEvaluationsHistory },
  props: { studentSieId: { type: [String, Number], default: null } },
};
</script>
